<template>
  <div class="title-overview-popover-container">
    <el-popover
      placement="top"
      trigger="click"
    >
      <div class="title-overview-popover-text" v-html="content"></div>
      <i slot="reference" class="activeIconHover icon iconfont iconicon_document_details"></i>
    </el-popover>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      default: '',
    }
  },

}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
.iconicon_document_details  {
  @include fontColorOpacity(.6);
}
.title-overview-popover-text {
  max-width: 320px;
  padding: 16px;
  box-sizing: border-box;
  /deep/ p {
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 16px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
